var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 3.43945C6.36207 3.43945 5.02954 4.77198 5.02954 6.40986C5.02954 8.04773 6.36207 9.38027 7.99995 9.38027C9.63782 9.38027 10.9704 8.04773 10.9704 6.40986C10.9704 4.77198 9.63785 3.43945 7.99995 3.43945ZM7.99995 8.12958C7.0517 8.12958 6.28023 7.35811 6.28023 6.40986C6.28023 5.46161 7.0517 4.69014 7.99995 4.69014C8.9482 4.69014 9.71967 5.46161 9.71967 6.40986C9.71967 7.35811 8.9482 8.12958 7.99995 8.12958Z",
    fill: "#008080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 0C4.46565 0 1.59021 2.87547 1.59021 6.40984V6.58703C1.59021 8.37453 2.61502 10.4575 4.63627 12.7781C6.10152 14.4603 7.5463 15.6333 7.60705 15.6824L8.00005 16L8.39305 15.6825C8.45384 15.6333 9.89862 14.4603 11.3638 12.7781C13.3851 10.4575 14.4099 8.37456 14.4099 6.58706V6.40987C14.4099 2.87547 11.5345 0 8.00005 0ZM13.1592 6.58706C13.1592 9.60784 9.26699 13.2646 8.00005 14.3746C6.73277 13.2642 2.8409 9.60763 2.8409 6.58706V6.40987C2.8409 3.56512 5.1553 1.25072 8.00005 1.25072C10.8448 1.25072 13.1592 3.56512 13.1592 6.40987V6.58706Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2202c67d1fbab3482e7c540b03ee737e.svg";
export { ForwardRef as ReactComponent };